<template lang="pug">
div
	div(v-if="resultados.galerias.length > 0")
		h3.font-primary
			span.fa.fa-folder.mr-3
			| Galerías encontradas ({{resultados.galerias.length}})
		mini-galeria(v-for="galeria in resultados.galerias", :key="galeria.GaleriaID", :galeria="galeria", @selecciona="verGaleria(galeria.GaleriaID)")
	div(v-if="resultados.items.length > 0")
		h3.font-primary
			span.fa.fa-image.mr-3
			| Ficheros encontrados ({{resultados.items.length}})
		mini-item(v-for="item in resultados.items", :key="item.ItemID", :item="item", @selecciona="verItem = item.ItemID")
	visor-item(v-if="verItem", @cerrar="verItem = null", :item-id.sync="verItem", :listado="listado")
</template>

<script>
import { mapGetters } from 'vuex'
import MiniItem from '../visor-item/mini-item'
import MiniGaleria from '../listado-galerias/mini-galeria'
import VisorItem from '../visor-item/visor-item'
export default {
	components: {
		'mini-item': MiniItem,
		'visor-item': VisorItem,
		'mini-galeria': MiniGaleria
	},
	data () {
		return {
			verItem: null
		}
	},
	computed: {
		...mapGetters({
			'resultados': 'galerias/buscador'
		}),
		listado () {
			return this.resultados.items.map(i => i.ItemID)
		}
	},
	methods: {
		verGaleria (GaleriaID) {
			this.$router.push('/main/galerias/' + GaleriaID)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/galerias/vue/componentes/buscador/vista-buscador.vue